<template>
  <div class="page-content conmon-top tabs-class">
      <el-tabs class="setting-tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="权益设置" name="first">
              <div>
                  <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right:0"></i>
          <span class="order-list-search-span" style="margin-left: 6px">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">收起查询</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">展开查询</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"> </i>
          <el-button class="search-btn-new" type="primary" size="small" @click="load">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
              <el-form-item label="权益名称:">
                <el-input v-model="formInlineTmp.in_title" placeholder="请输入会员权益名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
        <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-right:0"></i>
        <span class="order-list-search-span" style="margin-left: 6px">权益列表</span>
      </el-col>
                     <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addMemberInterestAction" class="add-btn" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        class="table"
        v-loading="loadSetting"
        :data="tableData">
        <el-table-column
          prop="in_title"
          label="会员权益名称">
        </el-table-column>
        <!-- <el-table-column
          label="图标">
          <template slot-scope="scope">
            <img :src="scope.row.in_logo" class="table-img">
          </template>
        </el-table-column> -->
        <el-table-column
          label="类型">
          <template slot-scope="scope">
            <div v-if="scope.row.in_type === 1">链接</div>
            <div v-if="scope.row.in_type === 2">实物</div>
          </template>
        </el-table-column>
        <el-table-column
          label="权益分类">
          <template slot-scope="scope">
            <div v-if="scope.row.in_type === 1">节日福利</div>
            <div v-if="scope.row.in_type === 2">会员专属日</div>
            <div v-if="scope.row.in_type === 3">生日福利</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="grade_list"
          label="适用会员等级">
          <template slot-scope="scope">
            <span v-for="id in scope.row.in_grade_list">{{memberLevelList[id]}}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          label="是否启用">
          <template slot-scope="scope">
            <div v-if="scope.row.in_status === 1" @click="switchChange(scope.row, 0)" class="enable-button red">禁用</div>
            <div v-if="scope.row.in_status === 0" @click="switchChange(scope.row, 1)" class="enable-button green">启用</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div class="op-link" @click="pushToInfoManage(scope.row.id)">
              编辑
            </div>
            <div class="op-link" @click="deleteAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
    </div>
          </el-tab-pane>
          <el-tab-pane label="权益订单" name="second">
              <div>
                  <div class="base-input ovf-hd" style="margin-bottom: 10px;">
                      <el-row class="search-title">
                          <el-col :span="4" class="search-nav-left">
                              <i class="el-icon-search" style="font-weight: bold;"></i>
                              <span class="order-list-search-span" style="margin-left:6px">筛选查询</span>
                          </el-col>
                          <el-col :span="20" class="search-nav-right">
                              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                              <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
                              <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
                              <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
                              <el-button class="search-btn-new" type="primary" size="small" @click="searchOrderData">查询</el-button>
                          </el-col>
                      </el-row>
                      <el-collapse-transition>
                          <div v-show="hide" class="search-content common-search-formtype" style="padding: 2px 0">
                              <el-form :inline="true" :model="orderFormInlineTmp" class="search-content-item">
                                  <!--<el-form-item label="订单编号:">-->
                                      <!--<el-input v-model="orderFormInline.order_num" placeholder="请输入订单编号" clearable></el-input>-->
                                  <!--</el-form-item>-->
                                  <!--<el-form-item label="订单时间:">-->
                                      <!--<el-date-picker style=""-->
                                                      <!--v-model="orderFormInline.create_time"-->
                                                      <!--type="date"-->
                                                      <!--placeholder="订单时间"-->
                                                      <!--value-format="yyyy-MM-dd">-->
                                      <!--</el-date-picker>-->
                                  <!--</el-form-item>-->
                                  <!--<el-form-item label="会员编号:">-->
                                      <!--<el-input v-model="orderFormInline.vip_card" placeholder="请输入会员编号" clearable></el-input>-->
                                  <!--</el-form-item>-->
                                  <!--<el-form-item label="会员姓名:">-->
                                      <!--<el-input v-model="orderFormInline.truename" placeholder="请输入会员姓名" clearable></el-input>-->
                                  <!--</el-form-item>-->
                                  <!--<el-form-item label="收货人:">-->
                                      <!--<el-input v-model="orderFormInline.consignee_name" placeholder="请输入收货人姓名" clearable></el-input>-->
                                  <!--</el-form-item>-->
                                  <!--<el-form-item label="收货电话:">-->
                                      <!--<el-input v-model="orderFormInline.consignee_number" placeholder="请输入收货人电话" clearable></el-input>-->
                                  <!--</el-form-item>-->
                                  <el-form-item label="状态:">
                                      <el-select v-model="orderFormInlineTmp.status" placeholder="请选择状态">
                                          <el-option
                                                  v-for="item in orderStatusOptions"
                                                  :key="item.value"
                                                  :label="item.label"
                                                  :value="item.value">
                                          </el-option>
                                      </el-select>
                                  </el-form-item>
                              </el-form>
                          </div>
                      </el-collapse-transition>
                  </div>
                  <el-row class="search-title common-table-top" style="padding-right:0">
                      <el-col :span="4" style="text-align: left;">
                          <i class="el-icon-document" style="font-weight: bold;"></i>
                          <span class="order-list-search-span">数据列表</span>
                      </el-col>
                      <el-col :span="20" class="text-align-right">
                          <el-button type="primary" @click="orderSync" class="add-btn" style="float: right;">订单同步</el-button>
                          <el-button type="primary" @click="sendSync" class="add-btn" style="float: right;margin-right:16px">发货同步</el-button>
                          <el-button type="primary" @click="exporeAction" class="add-btn" style="float: right;margin-right:16px">excel导出</el-button>
                      </el-col>
                  </el-row>
                  <el-row class="import-data-title table-first-style">
                      <el-table
                              :data="orderData"
                              v-loading="loadOrderData"
                              class="table">
                          <el-table-column
                                  width="140"
                                  prop="order_num"
                                  label="订单编号">
                          </el-table-column>
                          <el-table-column
                                  width="155"
                                  prop="vip_card"
                                  label="会员编号">
                          </el-table-column>
                          <el-table-column
                                  width="70"
                                  prop="realname"
                                  label="姓名">
                          </el-table-column>
                          <el-table-column
                                  prop="consignee_number"
                                  width="110"
                                  label="手机号">
                          </el-table-column>
                           <el-table-column
                                  prop=""
                                  label="收货地址">
                              <template slot-scope="scope">
                                  <span>{{ scope.row.consignee_province }}- {{ scope.row.consignee_city }}-{{ scope.row.consignee_county }}</span>
                              </template>
                          </el-table-column>
                          <!-- <el-table-column
                                  prop="grade_name"
                                  label="会员等级">
                          </el-table-column> -->
                          <!-- <el-table-column
                                  prop="in_title"
                                  label="权益名称">
                          </el-table-column> -->
                          <el-table-column
                                  prop="in_gift_name"
                                  label="奖品名称">
                          </el-table-column>
                          <el-table-column
                                  label="类型">
                              <template slot-scope="scope">
                                  <div v-if="scope.row.in_type === 1">链接</div>
                                  <div v-if="scope.row.in_type === 2">实物</div>
                              </template>
                          </el-table-column>
                          <!-- <el-table-column
                                  prop="consignee_name"
                                  label="收货人">
                          </el-table-column> -->
                          <el-table-column
                                  width="135"
                                  label="时间">
                              <template slot-scope="scope">
                                  <span>{{ scope.row.create_time | formatDate }}</span>
                              </template>
                          </el-table-column>
                          <el-table-column
                                  width="80"
                                  prop=""
                                  label="状态">
                              <template slot-scope="scope">
                                <div v-if="scope.row.status === -1">发货失败</div>
                                <div v-if="scope.row.status === 0">未发货</div>
                                <div v-if="scope.row.status === 1">未发货</div>
                                <div v-if="scope.row.status === 2">已发货</div>
                              </template>
                          </el-table-column>
                          <el-table-column
                                  width="135"
                                  label="快递单号">
                              <template slot-scope="scope">
                                {{ scope.row.mail_no }}
                              </template>
                          </el-table-column>
                          <!-- <el-table-column label="操作" width="" style="display: flex;justify-content: center">
                              <template slot-scope="scope">
                                  <div class="op-link" v-if="scope.row.status === 0">
                                      <i class="iconfont icon-icon-bianji" style="font-size: 14px"></i>
                                      <span @click="changeInterestStatus(scope.row.id)">发货</span>
                                  </div>
                              </template>
                          </el-table-column> -->
                      </el-table>
                      <div class="table-foot">
                          <el-pagination
                                  class="table-foot-pagination"
                                  background
                                  @size-change="handleSizeChangeOrder"
                                  @current-change="handleCurrentChangeOrder"
                                  :page-size="limit"
                                  layout="total, prev, pager, next, jumper"
                                  :total="totalCount2">
                          </el-pagination>
                      </div>
                  </el-row>
              </div>
          </el-tab-pane>
      </el-tabs>
  </div>
</template>
<script>
import { getMemberIntereseList, changeMemberInterestStatus, deleteMemberInterest, getMemberLevelList, getMemberInterestOrderList, changeMemberInstrestOrderStatus, exportMemberInterestOrder, sendSyncMemberData, memberOrderSyncData } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      loadSetting: true,
      loadOrderData: true,
      orderFormInlineTmp: {
        status: ''
      },
      orderFormInline: {
        order_num: '',
        create_time: '',
        vip_card: '',
        truename: '',
        consignee_name: '',
        consignee_number: '',
        status: '',
        id: ''
      },
      hide: true,
      tableOrderData: [],
      totalCount2: 0,
      orderStatusOptions: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '未发货',
          value: '0'
        },
        {
          label: '已发货',
          value: '2'
        }
      ],
      addGradeForm: {
        grade: '',
        grade_list: []
      },
      addGradeDialog: false,
      formInlineTmp: {
        in_title: ''
      },
      formInline: {
        in_title: ''
      },
      activeName: 'first',
      tableData: [],
      orderData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      inGradeList: [],
      isSwitchClick: 1,
      // 会员等级
      memberLevelList: {},
      orderPage: 1
    }
  },
  methods: {
    searchOrderData() {
      this.orderFormInline = JSON.parse(JSON.stringify(this.orderFormInlineTmp))
      this.orderPage = 1
      this.getOrderData()
    },
    load() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    handleClick(tab, event) {
      this.getData()
      this.getOrderData()
    },
    isOnSaleAction() {
    },
    switchChange(row, in_status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeMemberInterestStatus(row.id, in_status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    addOfflineAcivityAction() {
      router.push('/home/add-offline-activity')
    },
    deleteAction(id) {
      this.$confirm('确认删除该权益?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMemberInterest(id).then(res => {
          if (res.data.code === 0) {
            this.getMemberLevel()
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
        })
      })
    },
    addMemberInterestAction() {
      router.push('/home/add-member-interest')
    },
    pushToInfoManage(Id) {
      router.push({path: '/home/edit-member-interest', query: { id: Id }})
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    // 处理订单分页
    handleSizeChangeOrder(val) {
      this.limit = val
      this.getOrderData()
    },
    handleCurrentChangeOrder(page) {
      this.orderPage = page
      this.getOrderData()
    },
    // 获取权益设置列表数据
    getData() {
      this.loadSetting = true
      getMemberIntereseList(this.page, this.formInline).then(res => {
        let array = res.data.data.list
        this.totalCount = res.data.data.total
        for (let item of array) {
          item.in_grade_list = item.in_grade_list.split(',')
          item.grade_list = [] // 列表放入空数组存放会员等级名称
        }
        for (let items of array) {
          for (let one of items.in_grade_list) {
            items.grade_list.push(this.memberLevelList[one]) // 取出对应的会员等级名称放入数组 grade_list
          }
          items.grade_list = items.grade_list.toString()
        }
        this.tableData = array
      })
      this.loadSet()
    },
    getMemberLevel() {
      getMemberLevelList(1, {}).then(res => {
        for (let i in res.data.data.list) {
          let item = res.data.data.list[i]
          this.memberLevelList[item.id] = item.level_title
        }
        this.getData()
      })
    },
    // 发货同步
    sendSync() {
      sendSyncMemberData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 订单同步
    orderSync() {
      memberOrderSyncData().then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '同步成功')
          this.getOrderData()
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // excel导出
    exporeAction() {
      exportMemberInterestOrder(this.orderFormInline).then(res => {
        this.download(res)
      })
    },
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    changeInterestStatus(id) {
      this.$confirm('确认发货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeMemberInstrestOrderStatus(id, '2').then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', res.data.error)
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取权益订单列表数据
    getOrderData() {
      this.loadOrderData = true
      // if (this.orderFormInline.consignee_number !== '') {
      //   let mobile = /^(13[0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/
      //   if (!mobile.test(this.orderFormInline.consignee_number)) {
      //     _g.toastMsg('error', '请填入正确手机号')
      //     return
      //   }
      // }
      getMemberInterestOrderList(this.orderPage, this.orderFormInline).then(res => {
        if (res.data.code === 0) {
          this.orderData = res.data.data.list
          this.totalCount2 = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.loadOrders()
    },
    // 数据加载时的动画
    loadSet() {
      setTimeout(() => {
        this.loadSetting = false
      }, 500)
    },
    loadOrders() {
      setTimeout(() => {
        this.loadOrderData = false
      }, 500)
    }
  },
  created() {
    this.getMemberLevel()
    this.getOrderData()
  },
  components: {
  }
}
</script>

<style scoped>
.enable-button {
  color: #1980FF;
  cursor: pointer;
  font-size: 12px;
}
.green{
    color: #05B324;
}
.red{
    color: #FF2B2B;
}
/*.setting-tabs {
  background-color: #fff;
  margin: 20px;
  padding: 10px;
}*/
</style>
